
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import moment from 'moment';

export default {
    setup() {
        const store = useStore();
        const task = store.state.task;
        const route = useRoute();
        const router = useRouter();
        const loginUser = JSON.parse(localStorage.loginUser);
        const userGuid = loginUser.UserGUID;
        const taskGuid = route.params.TaskGUID;
        const show = ref(false);
        const rejectRemark = ref('');
        const countTaskReq = ref(0);
        const messageInput = ref();

        const loading = computed(() => task.loading);
        const loadingRecieve = computed(() => task.loadingRecieve);
        const loadingReject = computed(() => task.loadingReject);
        const messageInfo = computed(() => (task.infos.length > 0 ? task.infos[0] : {}));

        const getTask = () => {
            countTaskReq.value++;
            return store.dispatch('task/CENTER_GET_TASK', { userGuid, taskGuid });
        };

        const getStatus = (status: number) => {
            switch (status) {
                case 101:
                    return '待接收';
                case 102:
                    return '已拒绝';
                default:
                    return '已接收';
            }
        };

        const formatDate = (date: string, type: number) => {
            if (!date || date === '') return '- -';
            return type === 1 ? moment(date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD HH:mm:ss');
        };

        const click = (isReceive: number) => {
            if (isReceive === 0) {
                show.value = true;
            }
            if (isReceive === 1) {
                store.dispatch('task/CENTER_RECEIVE_TASK', { userGuid, taskGuid, isReceive });
            }
        };
        const cancle = () => (show.value = false);
        const confirm = () => {
            show.value = false;
            store.dispatch('task/CENTER_REJECT_TASK', { userGuid, taskGuid, isReceive: 0, rejectRemark: rejectRemark.value });
        };

        // 监听结果
        watch(
            () => task.loading,
            (val: boolean, old: boolean) => {
                if (val === false && old === true) {
                    if (task.status === 0)
                        router.push({
                            name: 'notfound',
                        });
                }
            },
        );
        watch(
            () => task.loadingRecieve,
            (val: boolean, old: boolean) => {
                if (val === false && old === true) getTask();
            },
        );
        watch(
            () => task.loadingReject,
            (val: boolean, old: boolean) => {
                if (val === false && old === true) getTask();
            },
        );

        onMounted(() => {
            getTask().then(() => {
                let { refuse } = route.query;
                console.log('route.params  ', route.query);
                console.log('refuse ', refuse);
                console.log('messageInfo.value.WorkStatus ', messageInfo.value.WorkStatus);
                if (messageInfo.value.WorkStatus === 101) {
                    if (refuse === '1') {
                        show.value = true;
                        nextTick(() => {
                            messageInput.value.focus();
                        });
                    }
                }
            });
        });

        return {
            countTaskReq,
            loading,
            messageInfo,
            show,
            rejectRemark,
            getStatus,
            click,
            formatDate,
            cancle,
            confirm,
            loadingRecieve,
            loadingReject,
            messageInput,
        };
    },
};
